import React, { memo } from 'react';
import PropTypes from 'prop-types';
import onEnterPress from "../../../../helpers/onEnterPress";
var TabField = function TabField(_ref) {
  var name = _ref.name,
    selectTab = _ref.selectTab,
    checked = _ref.checked,
    count = _ref.count;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onClick: selectTab,
    onKeyDown: onEnterPress(selectTab),
    className: "tab-field".concat(checked ? ' checked' : '')
  }, name, count ? " (".concat(count, ")") : '');
};
TabField.propTypes = {
  name: PropTypes.string.isRequired,
  selectTab: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  count: PropTypes.number
};
TabField.defaultProps = {
  count: null
};
export default /*#__PURE__*/memo(TabField);